import type { IGraphics } from '../rendering/IRenderer';

export interface PlatformAccentBounds {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly id?: string;
}

/** Existing organic silhouette, shared unchanged by maps outside Tidewend town. */
export function drawOrganicPlatformAccent(
  graphics: Pick<IGraphics, 'fillPolygon'>,
  { x, y, width, height }: PlatformAccentBounds,
  isLedge: boolean,
  color: number,
  accentColor: number,
): void {
  if (isLedge) {
    graphics.fillPolygon([
      { x, y: y + 3 },
      { x: x + width * 0.12, y: y - 3 },
      { x: x + width * 0.34, y: y + 1 },
      { x: x + width * 0.56, y: y - 4 },
      { x: x + width * 0.78, y: y + 1 },
      { x: x + width, y: y - 1 },
      { x: x + width - 9, y: y + height - 2 },
      { x: x + width * 0.76, y: y + height + 7 },
      { x: x + width * 0.48, y: y + height + 1 },
      { x: x + width * 0.2, y: y + height + 6 },
      { x: x + 7, y: y + height - 2 },
    ], color, 1);
    graphics.fillPolygon([
      { x, y: y + 3 },
      { x: x + width * 0.12, y: y - 3 },
      { x: x + width * 0.34, y: y + 1 },
      { x: x + width * 0.56, y: y - 4 },
      { x: x + width * 0.78, y: y + 1 },
      { x: x + width, y: y - 1 },
      { x: x + width - 5, y: y + 8 },
      { x: x + 4, y: y + 9 },
    ], accentColor, 0.92);
  } else {
    graphics.fillPolygon([
      { x, y: y + 2 },
      { x: x + width * 0.08, y: y - 4 },
      { x: x + width * 0.19, y: y + 1 },
      { x: x + width * 0.33, y: y - 5 },
      { x: x + width * 0.48, y },
      { x: x + width * 0.63, y: y - 3 },
      { x: x + width * 0.79, y: y + 1 },
      { x: x + width * 0.91, y: y - 4 },
      { x: x + width, y: y + 1 },
      { x: x + width, y: y + 22 },
      { x, y: y + 22 },
    ], accentColor, 0.9);
  }
}
